import PropTypes from 'prop-types';

import useMartyContext from 'hooks/useMartyContext';

import css from 'styles/components/account/infoCard/deleteOverlay.scss';

const DeleteOverlay = ({ cardInfoText, hideDeleteConfirmation, onDeleteClick }) => {
  const { testId } = useMartyContext();
  return (
    <div className={css.deleteOverlay} data-test-id={testId('infoCardDeleteOverlay')}>
      <p>Are you sure you want to delete this {cardInfoText}?</p>
      <div>
        <button type="button" onClick={hideDeleteConfirmation} className={css.cancel} data-test-id={testId('cancelDelete')}>
          Cancel
        </button>
        <button type="button" onClick={onDeleteClick} className={css.delete} data-test-id={testId('confirmDelete')}>
          Confirm
        </button>
      </div>
    </div>
  );
};

DeleteOverlay.contextTypes = {
  testId: PropTypes.func
};

export default DeleteOverlay;
